'use client';

import { useEffect } from 'react';
import Script from 'next/script';
import { useSearchParams, usePathname } from 'next/navigation';

declare global {
  interface Window {
    ym: (id: number, method: string, options?: any) => void;
  }
}

export default function Metrika() {
  const pathName = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (typeof window.ym !== 'undefined') {
      window.ym(103326013, 'hit', window.location.href);
    }
  }, [pathName, searchParams]);

  return (
    <Script id='yandex-metrika'>
      {`
        (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

        ym(103326013, "init", {
          clickmap:true,
          trackLinks:true,
          accurateTrackBounce:true,
          webvisor:true
        });    
      `}
    </Script>
  );
}
